import React, { useEffect, useRef } from 'react';
import './styles.scss';
import { setSelectedRestaurantTab } from '../../common/features/restaurant/restaurantAction';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { cleanedPath } from '../../common/utils';
import { reservatonMenuApiCall } from '../../common/features/cart/cartActions';
import useFunctions from '../../hooks/functions';

interface MenuDrawerProps {
  showMenuDrawer: boolean;
  setShowMenuDrawer: (show: boolean) => void;
}
const MenuDrawer = ({ showMenuDrawer, setShowMenuDrawer }: MenuDrawerProps) => {
    const exploreMenu = useSelector((state: any) => state.restaurant.exploreMenu?.menu);
 const selectedTab = useSelector((state: any) => state.restaurant.selectedRestaurantTab);
  const restaurantMenuDetails = useSelector((state: any) => state.restaurant.restaurantMenuDetails);
  const restaurantMenuDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantMenuDetailLoading
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { restaurantSlug, itemName } = useParams<any>();
  const slugFromLocalStorage =
    localStorage.getItem('restaurant') && JSON.parse(localStorage.getItem('restaurant') || '');
  const selectedDeliveryType = useSelector((state: any) => state.restaurant.selectedDeliveryType);

  const { groupMenuExploreItems } = useFunctions();

  const lastKnownHasExploreRef = useRef(false);
  useEffect(() => {
    if (!restaurantMenuDetailLoading && restaurantMenuDetails?.length > 0) {
      lastKnownHasExploreRef.current = groupMenuExploreItems(restaurantMenuDetails).length > 0;
    }
  }, [restaurantMenuDetails, restaurantMenuDetailLoading]);
  const hasExploreItems =
    !restaurantMenuDetailLoading && restaurantMenuDetails?.length > 0
      ? groupMenuExploreItems(restaurantMenuDetails).length > 0
      : lastKnownHasExploreRef.current;
  const handleTabClick = (e: React.MouseEvent, tab: string) => {
    e.stopPropagation();
    dispatch(setSelectedRestaurantTab(tab));
    setShowMenuDrawer(false);
    localStorage?.setItem('selectedTab', tab);
  };
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowMenuDrawer(false);
  };
  return (
    <>
      {' '}
      {/* Mobile Menu Drawer */}
      {showMenuDrawer && (
        <div className="mobile-menu-drawer" onClick={handleClose}>
          <div className="mobile-menu-drawer-content">
            <div className="mobile-menu-drawer-header">
              <div className="mobile-menu-drawer-close-button" onClick={handleClose}>
                ✕
              </div>
            </div>
            <div className="mobile-menu-drawer-items">
              <div
                className={`menu-drawer-item  ${selectedTab === 'restaurantInfo' ? 'active' : ''}`}
                onClick={e => {
                  handleTabClick(e, 'restaurantInfo');
                  navigate(
                    `${cleanedPath(window.location.pathname, !!(itemName || ''))}/restaurantinfo`
                  );
                }}
              >
                Restaurant Info
              </div>
              {hasExploreItems ? (
                <div
                  className={`menu-drawer-item  ${selectedTab === 'explore' ? 'active' : ''}`}
                  onClick={e => {
                    handleTabClick(e, 'explore');
                    navigate(
                      `${cleanedPath(window.location.pathname, !!(itemName || ''))}/exploremenu`
                    );
                  }}
                >
                  Explore
                </div>
              ) : null}
              <div
                className={`menu-drawer-item  ${selectedTab === 'menu' ? 'active' : ''}`}
                onClick={e => {
                  handleTabClick(e, 'menu');
                  navigate(
                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${selectedDeliveryType}`
                  );
                }}
              >
                Full Menu
              </div>
              <div
                className={`menu-drawer-item  ${selectedTab === 'reservation' ? 'active' : ''}`}
                onClick={e => {
                  handleTabClick(e, 'reservation');
                  navigate(
                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/ReservationRevamp`
                  );
                  dispatch(reservatonMenuApiCall());
                }}
              >
                Reservation
              </div>
              <div
                className={`menu-drawer-item  ${selectedTab === 'checkIn' ? 'active' : ''}`}
                onClick={e => {
                  handleTabClick(e, 'checkIn');
                  navigate(
                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/CheckinRevamp`
                  );
                  dispatch(reservatonMenuApiCall());
                }}
              >
                Check In
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MenuDrawer;
